// These values come from API, we cannot change them
export const ALLOWED_DISTRIBUTION_LUMP_SUM = "LUMPSUM";
export const ALLOWED_DISTRIBUTION_INSTALLMENTS = "INSTALLMENT";

export const VALUE_INSTALLMENTS = "INSTALLMENTS";
export const VALUE_LUMP_SUM = "LUMP_SUM";

export const MINIMUM_REDEFERRAL_DATE_FORMAT = "MM/dd/yyyy";
export const ADJUSTED_DATE_FORMAT = "MM-dd-yyyy";